import { createApp } from 'vue'
import App from './App.vue'

const globalMixin = {
    methods: {
        thisCheck() {

        }
    }
}

createApp({
    extends: App,
    mixins: [globalMixin],
  }).mount('#app')

